<!--
 * @Author: your name
 * @Date: 2021-02-26 14:32:44
 * @LastEditTime: 2021-04-16 09:19:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/components/NavBar.vue
-->
<template>
  <div class="nav-container">
    <div class="header">
      <img
        class="back"
        src="@/images/back.png"
        v-if="has_back"
        @click="goBack"
      />
      {{ title }}
      <a class="login" v-if="has_right" @click="createReceiptTitle">{{
        right_text
      }}</a>
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import userHelper from "@/helpers/user_helper";
export default {
  props: {
    title: {
      type: String,
      default: "首页",
    },
    right_text: {
      type: String,
      default: "",
    },
    right_url: {
      type: String,
      default: "",
    },
    has_back: {
      type: Boolean,
      default: true,
    },
    has_right: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const router = useRouter();
    function goBack() {
     let lastRouter = userHelper.readLastRouter()
     let cur = userHelper.readRouterSession()
      if (cur.indexOf("charge_details") != -1 && (lastRouter == "Home" || lastRouter == "/")) {
          router.replace("/")
        return false;
      } else {
        router.back();
      }
    }
    function createReceiptTitle() {
      router.push("/user/receipt/title_editor");
    }
    return {
      goBack,
      createReceiptTitle,
    };
  },
};
</script>
<style  scoped>
.nav-container {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 999;
}
.header {
  height: 45px;
  background: #fff;
  border-bottom: 1px solid #eee;
  font-size: 18px;
  color: #333;
  z-index: 999;
  text-align: center;
  line-height: 45px;
  position: relative;
}
.login {
  position: absolute;
  right: 20px;
  top: 2px;
  font-size: 14px;
  color: #005aa0;
}
.back {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
}
</style>
